export default function MapAndStoresPanel({ selectedProduct, offers, selectedArea, userLocation }) {
  return (
    <section className="bg-white/95 border border-slate-200/80 rounded-2xl shadow-xl p-5 space-y-3">
      <header className="flex items-center justify-between gap-3">
        <h3 className="text-sm font-semibold">
          Nearby stores & map
          {selectedProduct ? ` – ${selectedProduct.name}` : ""}
        </h3>
        <span className="px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700 text-[0.7rem]">
          {selectedArea === "Near me" ? "Using your area" : `Area: ${selectedArea}`}
        </span>
      </header>

      <div className="grid gap-3 md:grid-cols-[minmax(0,1.3fr)_minmax(0,1.1fr)] text-xs">
        {/* <div className="rounded-xl border border-dashed border-slate-300 bg-gradient-to-br from-indigo-50 to-slate-100 px-3 py-3 space-y-1.5">
          <p className="font-semibold flex items-center gap-1.5 text-slate-800">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-white shadow-sm">
              <MapIcon className="w-3.5 h-3.5 text-indigo-600" />
            </span>
            Map preview placeholder
          </p>
          <p className="text-[0.72rem] text-slate-600">
            Here you can plug in Google Maps or Mapbox to show store pins around the
            selected area.
          </p>
          {userLocation && (
            <p className="text-[0.7rem] text-slate-500">
              Your location: {userLocation.lat.toFixed(3)}, {userLocation.lng.toFixed(3)}
            </p>
          )}
        </div> */}

        <div className="rounded-xl border border-slate-200 bg-slate-50/80 px-3 py-2.5">
          {selectedProduct && offers.length > 0 ? (
            <ul className="space-y-1.5 max-h-44 overflow-y-auto pr-1">
              {offers
                .slice()
                .sort((a, b) => a.branches[0].distanceKm - b.branches[0].distanceKm)
                .map((offer) => (
                  <li
                    key={offer.offerId}
                    className="flex items-center gap-2 py-1 border-b last:border-b-0 border-dashed border-slate-200"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-indigo-600" />
                    <div className="flex-1 min-w-0">
                      <p className="text-[0.8rem] font-semibold truncate">
                        {offer.store?.storeName || "Store Name"}
                      </p>
                      <p className="text-[0.7rem] text-slate-500">
                        {offer.branches[0].branchName} · {offer.branches[0].distanceKm.toFixed(1)} km
                      </p>
                    </div>
                    <span className="text-[0.78rem] font-semibold text-slate-900">
                      AED {offer.offerPrice.toLocaleString()}
                    </span>
                  </li>
                ))}
            </ul>
          ) : (
            <p className="text-[0.74rem] text-slate-600">
              Once you pick a product, we will list the nearest branches with prices
              here.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}